import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './Tooltip.css';

class Tooltip extends Component {
    constructor(props) {
      super(props)  
      this.state = {
        displayTooltip: this.props.displayTooltip
      }
      this.hideTooltip = this.hideTooltip.bind(this)
      this.showTooltip = this.showTooltip.bind(this)
    }
    
    hideTooltip () {
      this.setState({displayTooltip: false})      
    }
    showTooltip () {
      this.setState({displayTooltip: true})
      setTimeout(() => {
        this.setState({displayTooltip: false})
      }, 1500);
    }
  
    render() {
      let message = this.props.message
      return (
        <span className='tooltip'>
          {this.state.displayTooltip &&
          <div className={`tooltip-bubble tooltip-bottom`}>
            <div className='tooltip-message'>{message}</div>
          </div>
          }
        </span>
      )
    }
  }

  Tooltip.propTypes = {
    displayTooltip: PropTypes.bool,
    message: PropTypes.string
  }

  export default Tooltip;